import { api, LightningElement } from "lwc";
import type { ProductSummary } from "../productTile/types";

export default class ProductCollection extends LightningElement {
  @api items: ProductSummary[] = null!;
  @api itemTitles: string[] = null!;
}
